<template>
  <div class="withdraw-wrap">
    <div>
      <el-button size="mini" type="primary" @click="getList">刷新</el-button>
      <el-button size="mini" type="primary" @click="withdraw_export_csv">导出</el-button>
    </div>
    <div>
      <el-descriptions :column="3" border size="mini" :labelStyle="{width: '100px'}" :contentStyle="{width:'calc((100% / 3) - 100px)'}">
        <el-descriptions-item label="来源">
          <el-input size="mini" v-model="where.origin" style="width: 100%" @change="pageChange(1)"></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="姓名">
          <el-input size="mini" v-model="where.realname" style="width: 100%" @change="pageChange(1)"></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="提现手机号">
          <el-input size="mini" v-model="where.mobile" style="width: 100%" @change="pageChange(1)"></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="认证手机号">
          <el-input size="mini" v-model="where.u_mobile" style="width: 100%" @change="pageChange(1)"></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="身份证号">
          <el-input size="mini" v-model="where.idcard" style="width: 100%" @change="pageChange(1)"></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="银行名称">
          <el-input size="mini" v-model="where.bank_name" style="width: 100%" @change="pageChange(1)"></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="银行卡号">
          <el-input size="mini" v-model="where.bank_account" style="width: 100%" @change="pageChange(1)"></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="金额">
          <el-input size="mini" v-model="where.amount" style="width: 100%" @change="pageChange(1)"></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-select size="mini" v-model="where.status" placeholder="请选择" @change="pageChange(1)">
            <el-option v-for="item in statusList" :label="item.name" :value="item.value" :key="item.value"></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="订单编号">
          <el-input size="mini" v-model="where.merchant_sn" style="width: 100%" @change="pageChange(1)"></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="协议号">
          <el-input size="mini" v-model="where.xcy_contract_sn" style="width: 100%" @change="pageChange(1)"></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="欢创订单号">
          <el-input size="mini" v-model="where.sn" style="width: 100%" @change="pageChange(1)"></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="民生转账ID">
          <el-input size="mini" v-model="where.mingsheng_id" style="width: 100%" @change="pageChange(1)"></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="申请时间">
          <el-date-picker size="mini" v-model="where.create_time" type="datetimerange" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="pageChange(1)"></el-date-picker>
        </el-descriptions-item>
        <el-descriptions-item label="更新时间">
          <el-date-picker size="mini" v-model="where.update_time" type="datetimerange" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="pageChange(1)"></el-date-picker>
        </el-descriptions-item>
      </el-descriptions>
    </div>
<!--    状态：0=待支付1=已支付2=不符合发放状态3=支付失败4=处理中 5=支付异常 -->
    <div class="header-tip">
      提现总额： {{formatMoney(total_object.total_amount||0,2)}} 元&nbsp;&nbsp;&nbsp;&nbsp;
      提现成功： {{formatMoney(total_object.status_amount_1||0,2)}} 元&nbsp;&nbsp;&nbsp;&nbsp;
      <br />
      提现申请中： {{formatMoney(total_object.status_amount_0||0,2)}} 元&nbsp;&nbsp;&nbsp;&nbsp;
      不符合发放状态： {{formatMoney(total_object.status_amount_2||0,2)}} 元&nbsp;&nbsp;&nbsp;&nbsp;
      支付失败： {{formatMoney(total_object.status_amount_3||0,2)}} 元&nbsp;&nbsp;&nbsp;&nbsp;
      处理中： {{formatMoney(total_object.status_amount_4||0,2)}} 元&nbsp;&nbsp;&nbsp;&nbsp;
      支付异常： {{formatMoney(total_object.status_amount_5||0,2)}} 元&nbsp;&nbsp;&nbsp;&nbsp;
      资金驳回： {{formatMoney(total_object.status_amount_6||0,2)}} 元&nbsp;&nbsp;&nbsp;&nbsp;
      无效提现： {{formatMoney(total_object.status_amount_7||0,2)}} 元&nbsp;&nbsp;&nbsp;&nbsp;
    </div>
    <div class="table-wrap">
      <el-table
        v-loading="loading"
        v-if="pageData.list.length > 0" :data="pageData.list"
        border class="table-wrap-table" height="55vh">
        <el-table-column prop="id" label="id" width="80" fixed></el-table-column>
        <el-table-column prop="origin" label="来源" width="100" fixed></el-table-column>
        <el-table-column prop="realname" label="姓名" width="100" fixed></el-table-column>
        <el-table-column prop="mobile" label="提现手机号码" width="100"></el-table-column>
        <el-table-column prop="u_mobile" label="认证手机号码" width="100"></el-table-column>
        <el-table-column prop="idcard" label="身份证号" width="180"></el-table-column>
        <el-table-column prop="bank_name" label="银行名称" width="100"></el-table-column>
        <el-table-column prop="bank_account" label="银行卡号" width="180"></el-table-column>
        <el-table-column prop="amount" label="金额" width="100"></el-table-column>
        <el-table-column prop="status" label="状态" width="120">
          <template slot-scope="scope">
            {{statusObj[scope.row.status+'']}}
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" width="100"></el-table-column>
        <el-table-column prop="merchant_sn" label="订单编号" width="200"></el-table-column>
        <el-table-column prop="xcy_contract_sn" label="协议号" width="150"></el-table-column>
        <el-table-column prop="sn" label="欢创订单号" width="180"></el-table-column>
        <el-table-column prop="mingsheng_id" label="民生转账ID" width="100"></el-table-column>
        <el-table-column prop="system_remark" label="系统备注" width="180">
          <template slot-scope="scope">
            <code>
              {{scope.row.system_remark}}
            </code>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="申请时间" width="150"></el-table-column>
        <el-table-column prop="update_time" label="更新时间" width="150"></el-table-column>
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="scope">
<!--            <el-button v-if="scope.row.status == -4" type="primary" size="mini" @click="handleEdit(scope.row)">调整</el-button>-->
            <el-button v-if="scope.row.status == 3 || scope.row.status == 5" type="primary" size="mini" @click="reapply(scope.row)">驳回资金</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-wrap">
      <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
                     :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
                     @current-change="pageChange"></el-pagination>
    </div>
    <WithdrawForm ref="withdrawForm" />
  </div>
</template>

<script>
import ButlerHttp from "./common/ButlerHttp";
import WithdrawForm from "./components/WithdrawForm";

export default {
  name: "Withdraw",
  components: {WithdrawForm},
  data() {
    return {
      loading: false,
      statusList: [
        //状态：0=待支付1=已支付2=不符合发放状态3=支付失败4=处理中 5=支付异常
        {name: "全部", value: ""},
        {name: "待支付", value: "0"},
        {name: "已支付", value: "1"},
        {name: "不符合发放状态", value: "2"},
        {name: "支付失败", value: "3"},
        {name: "处理中", value: "4"},
        {name: "支付异常", value: "5"},
        {name: "资金驳回", value: "6"},
        {name: "无效提现", value: "7"},
      ],
      statusObj:{
        "0": "待支付",
        "1": "已支付",
        "2": "不符合发放状态",
        "3": "支付失败",
        "4": "处理中",
        "5": "支付异常",
        "6": "资金驳回",
        "7": "无效提现"
      },
      where: {
        origin: "",
        realname: "",
        mobile: "",
        idcard: "",
        bank_name: "",
        bank_account: "",
        amount: "",
        status: "",
        merchant_sn: "",
        xcy_contract_sn: "",
        sn: "",
        mingsheng_id: "",
        create_time: "",
        update_time: ""
      },
      pageData: {
        list: [],
        page: 1,
        pageSize: 20,
        total: 100
      },
      total_object:{},
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    pageChange(page) {
      this.pageData.page = page;
      this.getList();
    },
    getList() {
      const that = this;
      that.loading = true;
      let where = that.where;
      let url="https://djshop.51homemoney.com/index.php/api/withdraw2/get_withdraw_list?token_key=4d510e0cf43132fe923c2fadebdca552";
      ButlerHttp.post(url, {
        ...where,
        page: that.pageData.page,
        pageSize: that.pageData.pageSize
      },ret=>{
        that.loading = false;
        if(ret.code){
          ret.data.list.map(ret=>{
            ret.system_remark=decodeURIComponent(ret.system_remark);
          })
          that.pageData = ret.data;
          that.total_object = (ret.data||{}).total_object||{};
        }else {
          that.$message.error(ret.msg||"获取提现列表失败");
        }
      })
    },
    handleEdit(row) {
      const that = this;
      that.$refs.withdrawForm.show(row,(data)=>{
        row = data;
      });
    },
    reapply(row) {
      const that = this;
      that.$confirm('确认驳回该提现申请？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let url="https://djshop.51homemoney.com/index.php/api/withdraw2/withdraw_reject?token_key=4d510e0cf43132fe923c2fadebdca552";
        ButlerHttp.post(url, {
          id: row.id
        },ret=>{
          that.loading = false;
          if(ret.code){
            that.$message.success("提现申请已驳回");
            that.getList();
          }else {
            that.$message.error(ret.msg||"驳回提现申请失败");
          }
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    withdraw_export_csv(){
      const that = this;
      let url="https://djshop.51homemoney.com/index.php/api/withdraw2/withdraw_export_csv?token_key=4d510e0cf43132fe923c2fadebdca552";
      let where = that.where;
      ButlerHttp.post(url, {
        ...where
      },ret=>{
        that.loading = false;
        if(ret.code){
          let file_url = ret.data.file_url;
          window.open(file_url);
        }else {
          that.$message.error(ret.msg||"获取提现列表失败");
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./common";

.withdraw-wrap {
  .header-tip{
    margin: 5px 0;
    padding: 5px 10px;
    background-color: #f56c6c;
    color: #FFFFFF;
    border-radius: 4px;
    display: inline-block;
  }
  padding: 20px;
  .table-wrap-table {
     .el-table__fixed-header-wrapper {
        background-color: #f5f5f5;
      }
    }
  .pagination-wrap {
     .el-pagination {
        margin-top: 20px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/Withdraw.vue